import React, { Component } from "react";
import { Icon } from "../../components/Icon";

/**
 * Row of small avatar buttons for launching project insights.
 *
 * Props:
 *  - onPlotClick(tab?): void     — opens the unified project insights modal (optional tab key)
 *  - onProgressClick(): void     — opens the writing progress modal
 *  - onIssuesClick(): void       — opens the board kanban modal
 *  - projectIssuesCount: number
 *  - progressPercent: number
 */
class ProjectStepsButtons extends Component {
  render() {
    const { onPlotClick, onProgressClick, onIssuesClick, projectIssuesCount, progressPercent } = this.props;
    const boardCount = Math.max(0, Number(projectIssuesCount) || 0);
    const boardCountLabel = boardCount > 99 ? '99+' : String(boardCount);
    const normalizedProgress = Math.max(0, Math.min(100, Math.round(Number(progressPercent) || 0)));
    const progressTitle = `Writing Progress ${normalizedProgress}%`;

    return (
      <div className="project-steps-buttons">
        <div className="steps-btn-group">
          <button
            type="button"
            className="scenes-avatar-btn"
            onClick={() => onPlotClick('plot')}
            title="View Plot"
            aria-label="View Plot"
          >
            <span className="scenes-avatar-icon"><Icon.PlotStructure /></span>
            <span className="scenes-avatar-hint">Plot</span>
          </button>
          <button
            type="button"
            className="scenes-avatar-btn"
            onClick={onIssuesClick}
            title="Kanban Board"
            aria-label="Kanban Board"
          >
            <span className="scenes-avatar-icon">
              <Icon.Board />
              {boardCount > 0 && (
                <span className="scenes-avatar-count scenes-avatar-count--high" aria-hidden="true">{boardCountLabel}</span>
              )}
            </span>
            <span className="scenes-avatar-hint">Board</span>
          </button>
          <button
            type="button"
            className="scenes-avatar-btn"
            onClick={onProgressClick}
            title={progressTitle}
            aria-label={progressTitle}
          >
            <span className="scenes-avatar-icon">
              <svg className="project-progress-icon-svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.8" opacity="0.35" />
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeDasharray={`${Math.round((normalizedProgress / 100) * 63)} 63`}
                  transform="rotate(-90 12 12)"
                />
                <text x="12" y="14" textAnchor="middle" className="project-progress-icon-svg__label">{normalizedProgress}</text>
              </svg>
            </span>
            <span className="scenes-avatar-hint">Progress</span>
          </button>
        </div>
      </div>
    );
  }
}

export default ProjectStepsButtons;
